import { render } from "./SpiritOfJapan4.vue?vue&type=template&id=fd1e998c&scoped=true"
import script from "./SpiritOfJapan4.vue?vue&type=script&lang=js"
export * from "./SpiritOfJapan4.vue?vue&type=script&lang=js"

import "./SpiritOfJapan4.scss?vue&type=style&index=0&id=fd1e998c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd1e998c"]])

export default __exports__